import { Component } from '@angular/core'
import { Router } from '@angular/router'

@Component({
  selector: 'app-not-found-error',
  templateUrl: './not-found-error.component.html',
  styleUrls: ['./not-found-error.component.scss'],
  standalone: false,
})
export class NotFoundErrorComponent {
  constructor(private router: Router) {}

  goHome() {
    this.router.navigate(['/'])
  }
}
